import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { ApiErrors } from "./ApiErrors";

export interface SaveCourseProductParams {
  id: number;
  name: string;
  division: number;
  closureDate?: Date | null;
  active?: boolean;
  productCategoryId?: number;
  intensityId?: number;
  languageId?: number;
  accountCategoryId?: number;
   productCategoryText?: string;
  accountCategoryText?: string;
  courseIntensityText?: string;
  courseLanguageText?: string;
  minimumAge?: number | null;
  minimumWeeks?: number | null;
  unitTypeId?: number;
  unitTypeText?: string;
}

export async function saveCourseProduct(
  product: SaveCourseProductParams,
  divisionId: number,
): Promise<{ ok: boolean; message: string; errors?: string[]; data?: any }> {
  const localApi = await getLocalApi();

  const payload = {
    productId: product.id,
    productName: product.name,
    closureDate: product.closureDate
      ? product.closureDate.toISOString().split("T")[0]
      : null,
    accountCategoryId: product.accountCategoryId ?? 0,
    accountCategoryText: product.accountCategoryText ?? '',
  
    productCategoryId: product.productCategoryId ?? 0,
    productCategoryText: product.productCategoryText ?? '',
  
    active: product.active ?? true,
  
    courseIntensityId: product.intensityId ?? 0,
    courseIntensityText: product.courseIntensityText ?? '',
  
    courseLanguageId: product.languageId ?? 0,
    courseLanguageText: product.courseLanguageText ?? '',

    minimumAge: product.minimumAge ?? null,
    minimumWeeks: product.minimumWeeks ?? null,

    unitTypeId: product.unitTypeId ?? 0,
    unitTypeText: product.unitTypeText ?? "",
  };

  const method = "PUT";
  const result = await localApi.call(
    apiConfig.courses_save.replace("{divisionId}", divisionId.toString()),
    method,
    JSON.stringify(payload)
  );

  if (!result) {
    return {
      ok: false,
      message: "No response from API",
      data: null
    };
  }

  const text = await result.text();
  const data = text ? JSON.parse(text) : null;

  const errors = ApiErrors.extractAllErrors(data, result, "Failed to save course product");
  const message = result.ok
    ? (data?.message || "Saved")
    : ApiErrors.formatErrors(errors);

  return {
    ok: result.ok,
    message,
    errors: result.ok ? undefined : errors,
    data: data
  };
}
